import { KnowledgeItemsWidget } from './knowledge-items-widget';
import { useSelector } from 'react-redux';
import { getSelectedWorkspaceId } from 'shared/store/selectors/workspace.selector';
import {
  useRecentlyCreatedItems,
  useRecentlyUpdatedItems,
} from 'shared/hooks/knowledge-dashboard.hooks';

export const actions = {
  RECENTLY_UPDATED_ITEMS: 'RECENTLY_UPDATED_ITEMS',
  RECENTLY_CREATED_ITEMS: 'RECENTLY_CREATED_ITEMS',
};

/** Both hooks are called so hook order stays static; `enabled` picks which one fetches. */
export function RecentUpdatedWidget({
  widgetKey,
  title,
  type,
  action = actions.RECENTLY_UPDATED_ITEMS,
}) {
  const workspaceId = useSelector(getSelectedWorkspaceId);
  const isCreatedVariant = action === actions.RECENTLY_CREATED_ITEMS;

  const created = useRecentlyCreatedItems(workspaceId, { enabled: isCreatedVariant });
  const updated = useRecentlyUpdatedItems(workspaceId, { enabled: !isCreatedVariant });
  const { data, isPending } = isCreatedVariant ? created : updated;

  // `null` is the widget's loading state; `[]` renders the empty state.
  const items = isPending ? null : (data ?? []);

  return <KnowledgeItemsWidget title={title} type={type} key={widgetKey} items={items} />;
}
